import { render, staticRenderFns } from "./TrainingCreate.vue?vue&type=template&id=36725b2d&scoped=true&"
import script from "./TrainingCreate.vue?vue&type=script&lang=ts&"
export * from "./TrainingCreate.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingCreate.vue?vue&type=style&index=0&id=36725b2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36725b2d",
  null
  
)

export default component.exports